export default __webpack_public_path__ + "static/media/canada-flag.d83869b3.svg";